const scenarioEndpoint = `${process.env.VUE_APP_URL}/api/v1/model/scenarios/`;

export default {
  namespaced: true,
  state: {
    scenarioData: {
      model: "",
      name: "",
      description: "",
      period_from: new Date(new Date().setMonth(new Date().getMonth() + -1)),
      period_to: new Date(),
      currency: "EUR",
    }
  },
  mutations: {
    SET_SCENARIO_DATA(state, data) {
      state.scenarioData = data;
    },
    CLEAR_SCENARIO_DATA(state) {
      let fromDate =
        new Date(new Date().setMonth(new Date().getMonth() + -1));
      let toDate = new Date();
      state.scenarioData = {
        model: "",
        name: "",
        description: "",
        period_from: fromDate,
        period_to: toDate,
        currency: "EUR",
      }
    },

    SET_SCENARIO_DATA_FIELD(state, { field, data }) {
      let newScenarioData = { ...state.scenarioData };
      newScenarioData[field] = data;

      state.scenarioData = newScenarioData;
    }

  },
  actions: {
    createUpdateScenario({ state, commit }, { context, model }) {
      var data = {
        model: model,
        name: state.scenarioData.name,
        description: state.scenarioData.description,
        period_from: new Date(state.scenarioData.period_from),// + "T00:00:00.000000Z",
        period_to: new Date(state.scenarioData.period_to),// + "T23:59:59.999999Z",
        currency: state.scenarioData.currency,
      };
      console.log(data);
      if (state.scenarioData.operationType == "UPDATE") {
        return context.$http.patch(`${scenarioEndpoint}${state.scenarioData.id}/`, data)
          .catch((err) => {
            console.error(err);
            return false;
          });
      }
      return context.$http.post(scenarioEndpoint, data)
        .catch((err) => {
          console.error(err);
          return false;
        });
    },
    async duplicateScenario({ state, commit }, { context, model, stepsToDuplicate, selectedScenarios}) {
      for (var i = 0; i < selectedScenarios.length; i++) {
        let scenarioName = `${selectedScenarios[i].name}_copy`.substring(0, 15);
        if(selectedScenarios.length == 1){
          scenarioName = state.scenarioData.name;
        }
        var data = {
          model: model,
          name: scenarioName,
          // Use new values from state when single scenario, otherwise use original values
          description: selectedScenarios.length == 1 ? state.scenarioData.description : selectedScenarios[i].description,
          period_from: selectedScenarios.length == 1 ? new Date(state.scenarioData.period_from) : new Date(selectedScenarios[i].period_from),
          period_to: selectedScenarios.length == 1 ? new Date(state.scenarioData.period_to) : new Date(selectedScenarios[i].period_to),
          currency: selectedScenarios[i].currency,
          scenario_id: selectedScenarios[i].id,
          stepsToDuplicate: stepsToDuplicate,
        };
        console.log(data);
        if(selectedScenarios.length == 1){
          return context.$http.post(`${scenarioEndpoint}duplicate/`, data);
        } else {
          await context.$http.post(`${scenarioEndpoint}duplicate/`, data);
        }
      }
    },
  }
}
